/**
 * displayValue
 *
 * Formats a nullable value for display, showing an em dash for null/undefined/empty string.
 *
 * Requirements: 18.18
 */
export function displayValue(value: unknown): string {
  if (value == null) return '\u2014';
  if (typeof value === 'string' && value.trim() === '') return '\u2014';
  if (typeof value === 'number') return value.toLocaleString();
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';

  return String(value);
}